import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialAsyncReduxState } from '../../constants';
import { defaultInternalOccupationDetail, InternalOccupationDetail } from '../../models/InternalOccupationDetail/InternalOccupationDetail';
import { AsyncReduxState } from '../../types';

export type InternalOccupationDetailState = AsyncReduxState<{
    internalOccupation: InternalOccupationDetail;
}>;

const initialState: InternalOccupationDetailState = {
    ...initialAsyncReduxState,
    isLoading: true,
    internalOccupation: defaultInternalOccupationDetail(),
};

export const internalOccupationDetailSlice = createSlice({
    name: 'internalOccupationDetailReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): InternalOccupationDetailState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): InternalOccupationDetailState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setInternalOccupation(state, action: PayloadAction<InternalOccupationDetail>): InternalOccupationDetailState {
            return {
                ...state,
                internalOccupation: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setError,
    setInternalOccupation,
} = internalOccupationDetailSlice.actions;

export default internalOccupationDetailSlice.reducer;
